import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import {
  getPastHighLevelTournamentsCount,
  getUpcomingHighLevelTournamentsCount
} from 'Src/helpers/service/adminSU/tournamentsTable';

type HighLevelTournamentSection = 'upcoming' | 'archive' | 'communications';

interface Props {
  user: AppUser;
  history: any;
  activeSection: HighLevelTournamentSection;
}

interface State {
  upcomingCount?: number;
  pastCount?: number;
}

const normalizeCount = (result: any): number => {
  const rawCount = result && result.count;
  const value = Number(rawCount && typeof rawCount === 'object' ? rawCount.count : rawCount);
  return isFinite(value) ? value : 0;
};

export class HighLevelTournamentsListHeader extends React.PureComponent<Props, State> {
  state: State = {};

  componentDidMount() {
    getUpcomingHighLevelTournamentsCount(this.props.user)
      .then(result => this.setState({ upcomingCount: normalizeCount(result) }))
      .catch(() => undefined);

    getPastHighLevelTournamentsCount(this.props.user)
      .then(result => this.setState({ pastCount: normalizeCount(result) }))
      .catch(() => undefined);
  }

  render() {
    const { activeSection, history } = this.props;
    const { upcomingCount, pastCount } = this.state;

    return (
      <div className="unionTournamentsHeader unionTournamentsPageHeader highLevelTournamentsPageHeader">
        <div className="highLevelTournamentsPageHeader__identity">
          <h1>High-level tournaments</h1>
        </div>
        <nav className="unionTournamentsTabs" aria-label="High-level tournament lists">
          <button
            type="button"
            className={activeSection === 'upcoming' ? 'isActive' : ''}
            onClick={() => history.push('/highLevelTournaments/upcoming')}
          >
            Upcoming {typeof upcomingCount === 'number' ? <span>{upcomingCount}</span> : null}
          </button>
          <button
            type="button"
            className={activeSection === 'archive' ? 'isActive' : ''}
            onClick={() => history.push('/highLevelTournaments/archive')}
          >
            Past {typeof pastCount === 'number' ? <span>{pastCount}</span> : null}
          </button>
          <button type="button" className={activeSection === 'communications' ? 'isActive' : ''} onClick={() => history.push('/highLevelTournaments/communications')}>Communications</button>
        </nav>
      </div>
    );
  }
}
